import React, { useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useLocation } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const PageWrapper = styled.div`
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  &.fade-enter {
    opacity: 1;
  }

  &.fade-enter-active {
    opacity: 0;
    animation: ${fadeOut} 300ms ease-in;
  }

  &.fade-exit {
    opacity: 0;
  }

  &.fade-exit-active {
    opacity: 1;
    animation: ${fadeIn} 300ms ease-in;
  }
`;

function PageTransition({ children }) {
  const location = useLocation();
  const nodeRef = React.useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <TransitionGroup component={null}>
      <CSSTransition
        key={location.key}
        timeout={600}
        classNames="fade"
        unmountOnExit
        nodeRef={nodeRef}
      >
        <PageWrapper ref={nodeRef}>
          {children}
        </PageWrapper>
      </CSSTransition>
    </TransitionGroup>
  );
}

export default PageTransition;